import ExpirationSoon from "./components/expiration/index.vue";
import StatisticCpd from "./components/statistic-cpd/index.vue";
import CostByBrand from "./components/cost-by-brand/index.vue";
import CostByPartner from "./components/cost-by-partner/index.vue";

export default {
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  components: {
    ExpirationSoon,
    StatisticCpd,
    CostByBrand,
    CostByPartner
  },
};
